"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "findResultsState", {
  enumerable: true,
  get: function get() {
    return _createInstantSearchServer.findResultsState;
  }
});
var _createInstantSearchServer = require("./core/createInstantSearchServer");